import React from "react";
//Components
import VerticalStepper from "../../../../components/VerticalStepper";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Typography from "@material-ui/core/Typography";
// Content for help
import { profile, dashboard, connections } from "./helpContent";
// styles
import { withStyles } from "@material-ui/core/styles";
import { styles } from "../../styles";

const Selector = props => {
  const { classes, handleSelect, values, value } = props;

  return (
    <React.Fragment>
      <Typography variant="h6">Choose Connection</Typography>
      <FormControl className={classes.formControl}>
        <Select value={value} onChange={handleSelect} displayEmpty input={<OutlinedInput labelWidth={0} />}>
          {values.map((value, key) => (
            <MenuItem value={value} key={key}>
              {value}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </React.Fragment>
  );
};

const SelectorStyled = withStyles(theme => ({
  root: {
    display: "flex",
    flexWrap: "wrap"
  },
  formControl: {
    margin: "10px 0px 10px 0px",
    minWidth: 120,
    width: "100%"
  },
  selectEmpty: {
    marginTop: theme.spacing(1)
  }
}))(Selector);

class Help extends React.Component {
  state = {
    content: undefined,
    selectedValue: "Select connection"
  };

  componentDidMount() {
    this.setState({
      content: this.getContent()
    });
  }

  componentDidUpdate = prevProps => {
    if (prevProps.context !== this.props.context) {
      this.setState({
        content: this.getContent()
      });
    }
  };

  getContent = () => {
    switch (this.props.context) {
      case "Profile":
        return profile;
      case "Dashboard":
        return dashboard;
      case "Connections":
        return connections;
      default:
        return undefined;
    }
  };

  handleSelect = e => {
    this.setState(state => ({
      ...state,
      selectedValue: e.target.value
    }));
  };

  render() {
    const { classes } = this.props;
    const { content, selectedValue } = this.state;

    return content ? (
      <div className={classes.rightSidebar}>
        {content.general}
        {content.select ? (
          <SelectorStyled handleSelect={this.handleSelect} values={content.select} value={selectedValue} />
        ) : (
          undefined
        )}
        {content.stepper && selectedValue !== "Select connection" ? (
          <VerticalStepper
            title={content.stepper[selectedValue.toLowerCase()].titles}
            instructions={content.stepper[selectedValue.toLowerCase()].instructions}
          />
        ) : (
          undefined
        )}
      </div>
    ) : (
      <span />
    );
  }
}

export default withStyles(styles)(Help);
